/**
 * Query keys for the mobile app's distribution. The root value
 * 'app-distribution' is the invalidation convention; every build action
 * answers with the whole overview, written straight into `overview`.
 */
export const distributionKeys = {
  root: ['app-distribution'] as const,
  overview: ['app-distribution', 'overview'] as const,
  endpoints: ['app-distribution', 'endpoints'] as const,
  /** The public /health check (database, sync worker, Zoho state). */
  health: ['app-distribution', 'health'] as const,
};
